module.exports = __webpack_public_path__ + "img/dep_coffeeandtea@2x.37f305ce.png";